import { useEffect } from 'react';

/**
 * Hook to set HTTP status code for the current page
 * This is useful for SEO and proper HTTP status handling in SPAs
 */
function useHttpStatus(statusCode) {
  useEffect(() => {
    // Set the document title to include the status code
    const originalTitle = document.title;
    document.title = `${statusCode} - ${originalTitle}`;
    
    // For client-side routing, we can't change the actual HTTP status code
    // but we can set meta tags and other indicators
    const metaStatus = document.querySelector('meta[name="http-status"]');
    if (metaStatus) {
      metaStatus.setAttribute('content', statusCode.toString());
    } else {
      const meta = document.createElement('meta');
      meta.name = 'http-status';
      meta.content = statusCode.toString();
      document.head.appendChild(meta);
    }
    
    // Cleanup function to restore original title
    return () => {
      document.title = originalTitle;
    };
  }, [statusCode]);
}

export default useHttpStatus;
